import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'rawCottonCon',
    type: 'text',
    label: 'Raw Cotton(bales)',
  },
  {
    colSpan: 1,
    name: 'psfCon',
    type: 'text',
    label: 'PSF(kg)',
  },
  {
    colSpan: 1,
    name: 'viscoseCon',
    type: 'text',
    label: 'Viscose(kg)',
  },
  {
    colSpan: 1,
    name: 'cotWasteCon',
    type: 'text',
    label: 'Cotton Waste(kg)',
  },
  {
    colSpan: 1,
    name: 'acrylicCon',
    type: 'text',
    label: 'Acrylic(kg)',
  },
  {
    colSpan: 1,
    name: 'chipsCon',
    type: 'text',
    label: 'Chips',
  },
  {
    colSpan: 1,
    name: 'petChipsCon',
    type: 'text',
    label: 'Pet-chips(kg)',
  },
];

export const rawMatConAFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label),
  [fields[1].name]: yup.string().label(fields[1].label),
  [fields[2].name]: yup.string().label(fields[2].label),
  [fields[3].name]: yup.string().label(fields[3].label),
  [fields[4].name]: yup.string().label(fields[4].label),
  [fields[5].name]: yup.string().label(fields[5].label),
  [fields[6].name]: yup.string().label(fields[6].label),
};

const RawMatReqA = (props) => {
  return (
    <FormSection
      sectionName="Raw Material Consumption"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default RawMatReqA;
